/**
 * dms 门店店员
 * Created by stonewang on 2017/8/29.
 */
import {config, request, objectSerial} from 'Utils';

//门店店员列表
export function getSellerList(param) {
  return request(`${config.server}/api/v1/dms/store/getSellerList?${objectSerial(param)}`);
}
//新增或修改门店店员
export function saveOrUpdateSeller(param) {
  /*
   {
   active (integer, optional): 启用状态（1有效，失效） ,
   birthday (string, optional): 生日 ,
   dmsContactInfoList (Array[DmsContactInfo], optional): 联系信息列表 ,
   id (integer, optional): 主键ID ,
   name (string, optional): 姓名 ,
   post (integer, optional): 岗位（0店员，1店长） ,
   sex (string, optional): 性别 ,
   shopId (integer, optional): 门店Id ,
   userId (integer, optional): 关联的账号的ＩＤ
   }

   dmsContactInfoList: [
     {
       content (string, optional): 联系方式内容 ,
       id (integer, optional), //可不传
       relatedTableId (integer, optional):  //可不传，关联表id，根据related_table_type字段的不同，关联不同的表的主键id ,
       relatedTableType (integer, optional):  //可不传，关联表类型：1-渠道联系人；2-门店联系人；3-员工 ,
       type (integer, optional): 联系方式类型：1-手机；2-座机；3-Email；4-QQ；5-微信；6-钉钉
     }
   ]
  * */
  return request(`${config.server}/api/v1/dms/store/saveOrUpdateSeller`, {
    method: 'post',
    body: param,
  });
}
//店员详情
export function sellerDetail(param) {
  return request(`${config.server}/api/v1/dms/store/sellerDetail?id=${param}`);
}
//店员开通账号
export function openAccount(param) {
  return request(`${config.server}/api/v1/dms/store/openAccount?${objectSerial(param)}`);
}


// WEBPACK FOOTER //
// ./src/service/store/staff.js